import { put } from "../../../../utils/api";
import GenericViewDrawer1 from "../../GenericViewDrawer1";

const ViewDetailsDrawerOffsetCreditPurchase = ({
  open,
  onClose,
  data,
  setsnackOpen,
  fetchDataCallback,
  apiUrl,
}) => {
  if (!data) return null;

  const handleApprovalAction = async (action) => {
    try {
      const response = await put(`${apiUrl}/${data._id}`, {
        approvalStatus: action === "approve" ? "Accepted" : "Rejected",
      });
      if (response?.data) {
        setsnackOpen({
          open: true,
          message: response.data.message,
          severity: "success",
        });
        fetchDataCallback();
        onClose();
      }
    } catch (error) {
      setsnackOpen({
        open: true,
        message: error.message || "An error occurred",
        severity: "error",
      });
    }
  };

  const fields = [
    // {
    //   label: "Consumption Period",
    //   previous: `${data?.consumptionPeriod?.month}/${data?.consumptionPeriod?.year}`,
    //   requested: `${data?.editValue?.consumptionPeriod?.month || "—"}/${
    //     data?.editValue?.consumptionPeriod?.year || "—"
    //   }`,
    // },
    {
      label: "Vendor Registry",
      previous: data?.vendorRegistry,
      requested: data?.editValue?.vendorRegistry,
    },
    {
      label: "Project ID/Name",
      previous: data?.projectIdOrName,
      requested: data?.editValue?.projectIdOrName,
    },
    {
      label: "Project Type",
      previous: data?.projectType,
      requested: data?.editValue?.projectType,
    },
    {
      label: "Credits Purchased (tCO₂e)",
      previous: data?.creditsPurchased,
      requested: data?.editValue?.creditsPurchased,
    },
    {
      label: "Vintage Year",
      previous: data?.vintageYear,
      requested: data?.editValue?.vintageYear,
    },
    {
      label: "Applied Scopes",
      previous: data?.appliedScopes,
      requested: data?.editValue?.appliedScopes,
    },
    {
      label: "Remarks",
      previous: data?.remarks,
      requested: data?.editValue?.remarks,
    },
  ];

  return (
    <GenericViewDrawer1
      open={open}
      onClose={onClose}
      title="Offset Credit Purchase Details"
      fields={fields}
      documentsField={{
        label: "Documents",
        previous: data?.documents,
        requested: data?.editValue?.documents,
      }}
      timeline={data?.timeLine}
      editRemarkReason={data?.editRemarkReason}
      onApprove={() => handleApprovalAction("approve")}
      onReject={() => handleApprovalAction("reject")}
    />
  );
};

export default ViewDetailsDrawerOffsetCreditPurchase;
